import { ReactNode, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { AuthButton } from '@/components/Auth';
import { useAuth, useUserSSOInfo } from '@/hooks/useAuth/useAuth';
import { useLogout } from '@/hooks/useLogout';
import { supabase } from '@/utils/backend-auth';

import {
  useConfirmSSOEmailVerification,
  useSendSSOEmailVerification,
} from '../../hooks/useSwr';

export default function SSOEmailVerification() {
  const { isSSOEmailVerified } = useUserSSOInfo();
  const { session } = useAuth();
  const logout = useLogout();

  const { trigger: resendEmail } = useSendSSOEmailVerification();
  const { ssoProviderId } = useUserSSOInfo();
  const [queryParams] = useSearchParams();

  const { trigger, error: verificationError } =
    useConfirmSSOEmailVerification();

  const [hasTriedVerification, setHasTriedVerification] = useState(false);

  const token = queryParams.get('token');
  useEffect(() => {
    if (!isSSOEmailVerified && supabase && !hasTriedVerification && token) {
      trigger({
        json: {
          token,
        },
      });
      setHasTriedVerification(true);
    } else if (isSSOEmailVerified && supabase) {
      window.location.href = '/';
    }
  }, [isSSOEmailVerified, token, hasTriedVerification, trigger]);

  let content: ReactNode = 'Verifying email...';
  if (verificationError) {
    content = (
      <div className="text-red-500">
        Failed to verify email: {verificationError?.message}
      </div>
    );
  }

  return (
    <div className="flex w-[300px] flex-col gap-4">
      {content}
      <AuthButton
        onClick={() => {
          if (session && ssoProviderId) {
            resendEmail({
              json: {
                email: session?.user.email,
                saml_provider_id: ssoProviderId,
              },
            });
          }
        }}
        variant="primary"
      >
        Resend verification email
      </AuthButton>
      <AuthButton variant="secondary" onClick={() => logout()}>
        Logout
      </AuthButton>
    </div>
  );
}
